import { TError } from "./simple-result.models";

/**
 * The return type of anything that can fail: a key that will not decrypt, a
 * command ДПС refuses, a document that never arrived. Failure is a value here,
 * not an exception — the caller cannot forget to handle it, and the error
 * travels as a translation key rather than as a sentence in one language.
 *
 * Build one with the `create*Result` helpers rather than the constructor.
 */
export class SimpleResult<T> {
  success = false;
  error?: TError;
  /** Never rendered: the raw cause, kept for the console and support. */
  debugInfo?: unknown;
  data?: T;

  constructor(result?: Partial<SimpleResult<T>>) {
    Object.assign(this, result);
  }
}
